import { mutatorAction } from "satcheljs";
import getMyOutlookViewState from "../store/myOutlookViewState";

export const setMyOutlookFullPageShowingMutator: (isShowing: boolean) => void = mutatorAction("setMyOutlookFullPageShowingMutator", (isShowing: boolean): void => {
    getMyOutlookViewState().isFullPageShowing = isShowing;
});
